"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _clsx = _interopRequireDefault(require("../utils/clsx"));

var _pagination = require("./pagination.styles");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const PaginationHighlight = ({
  active,
  shadow,
  noMargin,
  rounded,
  css,
  ...props
}) => {
  const leftValue = (0, _react.useMemo)(() => noMargin ? `$$paginationSize * ${active}` : `$$paginationSize * ${active} + ${active * 4 + 2}px`, [active, noMargin]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_pagination.StyledPaginationHighlight, {
    "aria-hidden": true,
    shadow: shadow,
    rounded: rounded,
    className: (0, _clsx.default)('nextui-pagination-highlight', {
      'nextui-pagination-highlight--rounded': rounded,
      'nextui-pagination-highlight--active': active,
      'nextui-pagination-highlight--no-margin': noMargin,
      'nextui-pagination-highlight--shadow': shadow
    }),
    noMargin: noMargin,
    css: {
      left: `calc(${leftValue})`,
      ...css
    },
    ...props
  });
};

PaginationHighlight.toString = () => '.nextui-pagination-highlight';

var _default = PaginationHighlight;
exports.default = _default;
module.exports = exports.default;